import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'finSafe',
  standalone: false,
})
export class SafePipe implements PipeTransform {
  private sanitizer = inject(DomSanitizer);

  constructor() {
    const sanitizer = this.sanitizer;

    this.sanitizer = sanitizer;
  }

  transform(input: string, type: string): string {
    let value: unknown;

    if (!input) {
      input = '';
    }

    switch (type) {
      case 'html':
        value = this.sanitizer.bypassSecurityTrustHtml(input);
        break;
      case 'style':
        value = this.sanitizer.bypassSecurityTrustStyle(input);
        break;
      case 'script':
        value = this.sanitizer.bypassSecurityTrustScript(input);
        break;
      case 'url':
        value = this.sanitizer.bypassSecurityTrustUrl(input);
        break;
      case 'resource':
        value = this.sanitizer.bypassSecurityTrustResourceUrl(input);
        break;
      default:
        value = input;
        break;
    }

    if (value === '') {
      throw new Error(`Illegal type '${type}' given.`);
    }

    return value as string;
  }
}
